import { createFileRoute } from '@tanstack/react-router';
import { PortalPagesConsole } from '@/features/admin/PortalPagesConsole';

export const Route = createFileRoute('/_app/admin/portal-pages')({ component: PortalPagesConsole });
